import type { SearchResult } from 'components/Graph/GraphState';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';

export interface SetSearchResultCommand {
  searchResult: SearchResult | null;
}

export const setSearchResult: GraphCommandFactory<SetSearchResultCommand> =
  (cmdContext) => (command) => {
    cmdContext.updateState((draft) => {
      draft.searchResult = command.searchResult;
    });
  };
